import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { MenuController, NavController } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthReverseGuard  {
  private loader$ = new Subject<boolean>();
  public loader = false;

  constructor(
    public authService: AuthService,
    public menuCtrl: MenuController,
    public navController: NavController
  ) {}

  async canActivate(): Promise<boolean> {
    var isLogged = false;
    try {
      isLogged = await this.authService.checkAuthentication();
    } catch (error) {
      console.warn(error);
    }
    // If not is logged can enter to login and disable menu
    if (!isLogged) return this.goToLogin();
    this.navController.navigateRoot('/home');
    return false;
  }

  setShowLoader(show) {
    this.loader$.next(show);
  }

  async goToLogin() {
    let loginMethod = await this.authService.getLoginMethod();
    if (!loginMethod || loginMethod.type == 'normal') {
      return false;
    }
    return true;
  }
}
